module.exports = __webpack_public_path__ + "static/media/Slider 1 3.23b53c76.jpg";